<!-- 
程式：DataTableInput.vue
功能：檢核輸入table
作者：i9400539 鄧啓擇
完成：2020-08-01
-->
<template>
  <section class="newTable" v-if="options">
    <table
      :id="prefix"
      class="table datatable"
      :class="options.color === 'green' ? 'insurance-green' : 'insurance-blue'"
    >
      <thead>
        <tr>
          <th
            v-for="(item, index) in options.columns"
            :key="`table-tr-${index}`"
            :width="item.width || '*'"
            :class="{
              sorting: item.sorting,
              sorting_asc: item.sorting && order.index == index && order.asc,
              sorting_desc: item.sorting && order.index == index && !order.asc,
              'text-right': item.align && item.align === 'right'
            }"
            @click="item.sorting ? columnSorting(item.name, index) : false"
          >
            <span v-html="item.label"></span>
            <span
              v-if="item.headerWarning"
              class="waring-block d-inline-block"
              style="margin-left: 10px;"
            >
              <span class="dt-text">
                {{ item.headerWarning }}
              </span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody
        v-for="(insure, i) in tableData"
        :key="`${prefix}-${i}`"
        :id="`${prefix}-tr-${i}`"
      >
        <!-- 國泰壽險保單主約 -->
        <tr>
          <td
            v-for="(col, cid) in options.columns"
            :class="{ 'text-right': col.align && col.align === 'right' }"
            :width="col.width || '*'"
            :key="`${prefix}-col-${cid}`"
          >
            <span v-if="col.template" v-html="col.template(insure)"></span>
            <span v-else>
              <template v-if="col.validate">
                <!-- 下拉選單 -->
                <span v-if="col.options" class="text">
                  <select
                    class="form-control"
                    :data-vv-name="`${i}-name-${cid}`"
                    :class="{ 'is-invalid': errors.has(`${i}-name-${cid}`) }"
                    v-validate="'required'"
                    :data-vv-as="col.warningText || col.label"
                    v-model="insure[col.name]"
                  >
                    <option value>請選擇</option>
                    <template v-for="(item, key) in col.options">
                      <option :value="key" :key="`option_${key}`">
                        {{ item }}
                      </option>
                    </template>
                  </select>
                </span>

                <div v-else-if="col.type === 'date'" class="d-flex">
                  <date-picker
                    v-model="insure[col.name]"
                    :data-vv-as="col.warningText || col.label"
                    :format="dateFormatter"
                    :language="dateLang"
                    :first-day-of-week="1"
                    :input-class="{
                      'is-invalid': errors.has(`${i}-name-${cid}`)
                    }"
                    :data-vv-name="`${i}-name-${cid}`"
                    :typeable="true"
                    v-validate="{ required: insure.age == '' }"
                    @input="updateDateWithFormIndex(insure, i)"
                  />
                  <div
                    class="d-flex align-items-center"
                    style="margin-left: 12px;font-size: 22px;color:#F58818"
                  >
                    <i class="icon-calendar" />
                  </div>
                </div>

                <input
                  v-else-if="col.name === 'age'"
                  type="number"
                  min="0"
                  :data-vv-name="`${i}-name-${cid}`"
                  :placeholder="col.label"
                  v-model="insure[col.name]"
                  :class="{ 'is-invalid': errors.has(`${i}-name-${cid}`) }"
                  :data-vv-as="col.warningText || col.label"
                  v-validate="{
                    required: insure.age
                  }"
                  class="form-control"
                  :disabled="insure.ROCbirthday || insure.birthday"
                  alt="ch"
                  ref="age"
                />

                <input
                  v-else
                  type="text"
                  :data-vv-name="`${i}-name-${cid}`"
                  v-model="insure[col.name]"
                  :placeholder="col.label"
                  :data-vv-as="col.warningText || col.label"
                  :class="{ 'is-invalid': errors.has(`${i}-name-${cid}`) }"
                  v-validate="'required'"
                  class="form-control"
                  alt="ch"
                />
                <span class="waring-text-dt">
                  {{ errors.first(`${i}-name-${cid}`) }}
                </span>
              </template>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { computeAge } from "@/service/index";
import DatePicker from "@/components/DatePicker/components/Datepicker";
import { zh } from "@/components/DatePicker/locale";
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";

export default {
  name: "DataTableInput",
  mixins: [commonMixin],
  components: { DatePicker },
  props: {
    collapse: {
      type: Boolean,
      default: true
    },
    editMode: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "green"
    },
    prefix: {
      type: String,
      default: ""
    },
    tableTitle: {
      type: String,
      default: ""
    },
    currentPage: {
      type: Number,
      default: 0
    },
    totalpages: {
      type: Number,
      default: 0
    },
    scrollDataLoading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    options: {
      type: Object,
      default: () => {
        return null;
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modalLoading: {
      type: Boolean,
      default: false
    },
    DeleteBtn: {
      type: Boolean,
      default: false
    },
    checkPersonalId: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
    baseLink() {
      return `${window.location.origin}${window.location.pathname}`;
    }
  },
  data() {
    return {
      sexMap: {
        1: "男",
        2: "女"
      },
      status: {
        1: "配偶",
        2: "子女",
        3: "父母",
        4: "其他",
        5: "孫子女"
      },
      dateFormatter: date => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        const y = date.getFullYear();
        if (y < 1911) {
          return `${y}/${(m < 10 ? "0" : "") + m}/${(d < 10 ? "0" : "") + d}`;
        }
        return `${y - 1911}/${(m < 10 ? "0" : "") + m}/${(d < 10 ? "0" : "") +
          d}`;
      },
      dateLang: zh,
      tableList: this.tableData,
      order: {
        index: 0,
        asc: true
      },
      remoteDataMsg: "資料讀取中，請稍候...",
      currentWidth: 0,
      childStatus: []
    };
  },

  mounted() {
    this.initData();
  },
  watch: {
    tableData: "initData",
    collapse: "toggleAll"
  },
  methods: {
    callValidator() {
      this.$validator.validateAll().then(el => {
        if (el) {
          this.$emit("submit");
          this.$validator.reset();
        }
      });
    },

    getClientWidth(i, index) {
      if (!this.childStatus.length) return;

      let $th = Array.from(this.$el.querySelectorAll("th"));
      return $th[index].clientWidth;
    },
    initData() {
      this.tableData.forEach((insure, i) => {
        this.childStatus[i] = {
          render: false,
          show: false
        };
      });
    },
    toggleAll(val) {
      this.tableData.forEach((insure, i) => {
        if (this.childStatus[i].show !== val) this.toggleChild(insure, i);
      });
    },
    toggleChild(insure, i) {
      this.childStatus[i].show = !this.childStatus[i].show;
      this.$forceUpdate();
    },
    columnSorting(colName, index) {
      // 資料排序
      if (this.order.index === index) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.index = index;
        this.order.asc = true;
      }
      this.options.sorting(colName, this.order.asc);
    },
    updateDateWithFormIndex(data, index) {
      if (data.ROCbirthday) {
        computeAge(
          this.$store.state.userInfo.id,
          window.moment(data.ROCbirthday).format("YYYY-MM-DD")
        ).then(result => {
          if (result.header && result.header.status == "200") {
            data.age = result.body.age;
          } else {
            data.age = "計算錯誤";
          }
        });
        this.$refs.age[index].disabled = true;
      } else {
        this.$refs.age[index].disabled = false;
        data.age = "";
      }
    }
  }
};
</script>

<style scoped>
tr.child > td {
  padding: 0;
}
.waring-text-dt {
  margin-top: 5px;
  font-size: 13px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #de4054;
}

.waring-block .dt-text {
  /* width: 47px; */
  height: 18px;
  font-size: 13px;
  color: #323a45;
  line-height: 13px;
  position: relative;
  padding: 3px 0 0 12px;
  background: rgba(254, 237, 221);
  display: block;
}

.waring-block .dt-text:before {
  position: absolute;
  content: "*";
  color: red;
  top: 6px;
  left: 6px;
}
</style>
